/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SeasonDefinitionDto } from '../models/SeasonDefinitionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SeasonDefinitionControllerService {
    /**
     * @returns SeasonDefinitionDto OK
     * @throws ApiError
     */
    public static getAllSeasonDefinitions(): CancelablePromise<Array<SeasonDefinitionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-times',
        });
    }
    /**
     * @returns SeasonDefinitionDto OK
     * @throws ApiError
     */
    public static getCurrentOrNearest(): CancelablePromise<SeasonDefinitionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-times/current-or-nearest',
        });
    }
}
